<ng-container *vsLet="selectedAddons$ | async as selectedAddons">
  <ws-addon-picker
    *ngIf="selectedPlanAddons$ | async as addons"
    [addons]="addons"
    [selectedAddons]="selectedAddons"
    [formControl]="addonControl"
    [selectedTerm]="selectedTerm$ | async"
  ></ws-addon-picker>
</ng-container>
